import {SPORT_SPRITES_MAPPING} from '#core/utils/spritemap-storage/sport-sprites-mapping.js';

export function applicationViewAvantgardeFactory() {
    const ALL_SPORTS = Object.keys(SPORT_SPRITES_MAPPING).filter(sport => !['all'].includes(sport));
    const MARKET_BET_DISTRIBUTION = {
        market: {betDistribution: {enabled: true}},
    };

    return {
        DesignStyle: {
            style: 'avantgarde',
        },
        SearchControllerView: {
            appearance: 'discovery',
        },
        EventList: {
            hideAllMarketHeaders: true,
            header: {
                showTitle: false,
                disableMarketHeader: true,
            },
            marketsSection: {
                maxMarketColumnCount: 1,
            },
        },
        EventListSkeleton: {
            numberOfMarkets: 1,
            showEventListTitle: false,
            event: {
                participantsAndMarketsContainer: {
                    style: {
                        flexDirection: 'column',
                    },
                },
                marketContainer: {
                    style: {
                        _desktop_width: '100%',
                        flexGrow: 1,
                    },
                },
            },
        },
        EventListItem: {
            marketsSectionContainer: {
                container: {
                    itemSpacing: '8px',
                    style: {
                        width: '100%',
                        _mobile_width: '100%',
                        minWidth: '100%',
                        _mobile_minWidth: '100%',
                        flexGrow: 1,
                        flexShrink: 1,
                    },
                },
            },
            genericMarketContent: {
                market: {
                    selectionButton: {
                        view: {
                            nameDisplay: 'show short',
                            _mobile_nameDisplay: 'show short',
                        },
                    },
                },
            },
            longPressTapableContainer: {
                style: {
                    base: {
                        width: '100%',
                        height: 'calc(100% - 64px)',
                    },
                },
            },
        },
        SelectionButtonViewContainer: {
            transitionProperty: 'all',
            transitionDuration: '0.15s',
            transitionTimingFunction: 'ease-out',
        },
        ParticipantIconsInline: {
            competitorIconOptions: {
                enabledSports: ALL_SPORTS,
                icons: {
                    default: 'event-card/default-fallback.svg',
                },
            },
        },
        GenericMarketContent: MARKET_BET_DISTRIBUTION,
        CorrectScoreMarketContent: MARKET_BET_DISTRIBUTION,
        MarketLinesContent: MARKET_BET_DISTRIBUTION,
        SetScoreContent: MARKET_BET_DISTRIBUTION,
        BannerMarket: MARKET_BET_DISTRIBUTION,
    };
}
